import React from 'react'
import { goBack } from 'connected-react-router'
import { FocusMode } from '../../../../views/components'
import InviteUserForm from '../InviteUserForm/InviteUserForm'
import { useDispatch } from 'react-redux'

function InviteUserRoute(): React.ReactElement {
  const dispatch = useDispatch()

  return (
    <div className="root">
      <FocusMode
        isOpen
        onClose={() => dispatch(goBack())}
        title="Invite user"
        ContentComponent={() => <InviteUserForm />}
      />
    </div>
  )
}

export default InviteUserRoute
